var React = require('react');

function Clutch (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("title",{"key":1},"C icon"),React.createElement("path",{"d":"M55.1,57A22.35,22.35,0,0,1,40,62.6c-12.8,0-22.2-9.4-22.2-22.3S26.9,18.4,40,18.4a22.9,22.9,0,0,1,15.2,5.5L58,26.3,70.4,13.9,67.3,11A40.13,40.13,0,0,0,40,.8C17,0.8.3,17.4,0.3,40.2S17.4,80.1,40,80.1A40.14,40.14,0,0,0,67.5,69.7l3-2.8L57.9,54.5Z","transform":"translate(-0.3 -0.8)","key":2}),React.createElement("circle",{"cx":"39.1","cy":"39.6","r":"13.3","key":3})]);
}

Clutch.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 70.2 79.3"};

module.exports = Clutch;

Clutch.default = Clutch;
